export type VisitorStatus = 'داخل' | 'خرج' | 'منتهية الصلاحية' | 'ملغاة';
export type VisitorType = 'زائر' | 'مورد' | 'مقاول' | 'عميل' | 'سائق شاحنة' | 'عامل خارجي';
export type VisitPurpose = 'اجتماع عمل' | 'توريد مواد' | 'صيانة' | 'تفتيش' | 'زيارة رسمية' | 'تسليم شحنة';
export type GateNumber = 'البوابة الرئيسية' | 'بوابة الشاحنات' | 'البوابة الخلفية';

export interface Visitor {
  id: string;
  name: string;
  nationalId: string;
  mobile: string;
  company: string;
  type: VisitorType;
  photo: string;
  isBlacklisted: boolean;
  blacklistReason?: string;
}

export interface Visit {
  id: string;
  visitorId: string;
  visitorName: string;
  nationalId: string;
  mobile: string;
  company: string;
  type: VisitorType;
  purpose: VisitPurpose;
  hostDepartment: string;
  hostEmployee: string;
  gate: GateNumber;
  securityOfficer: string;
  entryTime: string;
  exitTime?: string;
  duration?: string;
  vehiclePlate?: string;
  passengersCount: number;
  badgeNumber: string;
  status: VisitorStatus;
  safetyAcknowledged: boolean;
  notes?: string;
}

export interface BlacklistEntry {
  id: string;
  name: string;
  nationalId: string;
  reason: string;
  addedBy: string;
  addedDate: string;
}

export const mockVisitors: Visitor[] = [
  {
    id: 'vis-001',
    name: 'أحمد محمد السيد',
    nationalId: '29801234567891',
    mobile: '01012345678',
    company: 'شركة الدلتا للمقاولات',
    type: 'مقاول',
    photo: 'https://i.pravatar.cc/150?img=11',
    isBlacklisted: false,
  },
  {
    id: 'vis-002',
    name: 'محمود عبد الرحمن خليل',
    nationalId: '29503214567892',
    mobile: '01123456789',
    company: 'مصنع النيل للكيماويات',
    type: 'مورد',
    photo: 'https://i.pravatar.cc/150?img=12',
    isBlacklisted: false,
  },
  {
    id: 'vis-003',
    name: 'كريم طارق عبد الله',
    nationalId: '29701234567893',
    mobile: '01234567890',
    company: 'شركة سيناء للتوريدات',
    type: 'سائق شاحنة',
    photo: 'https://i.pravatar.cc/150?img=13',
    isBlacklisted: false,
  },
  {
    id: 'vis-004',
    name: 'سامي حسن إبراهيم',
    nationalId: '29901234567894',
    mobile: '01512345678',
    company: 'شركة الخليج للاستشارات',
    type: 'زائر',
    photo: 'https://i.pravatar.cc/150?img=14',
    isBlacklisted: true,
    blacklistReason: 'تصرف مخالف لقواعد السلامة في زيارة سابقة',
  },
  {
    id: 'vis-005',
    name: 'عمرو فاروق النجار',
    nationalId: '29601234567895',
    mobile: '01612345678',
    company: 'مجموعة الشرق للصيانة',
    type: 'عامل خارجي',
    photo: 'https://i.pravatar.cc/150?img=15',
    isBlacklisted: false,
  },
  {
    id: 'vis-006',
    name: 'طارق عادل منصور',
    nationalId: '29201234567896',
    mobile: '01712345678',
    company: 'الشركة المصرية للمشتريات',
    type: 'عميل',
    photo: 'https://i.pravatar.cc/150?img=16',
    isBlacklisted: false,
  },
  {
    id: 'vis-007',
    name: 'خالد سعيد الزيات',
    nationalId: '29401234567897',
    mobile: '01812345678',
    company: 'شركة الإسكندرية للكيماويات',
    type: 'مورد',
    photo: 'https://i.pravatar.cc/150?img=17',
    isBlacklisted: false,
  },
  {
    id: 'vis-008',
    name: 'يوسف نبيل الحداد',
    nationalId: '29101234567898',
    mobile: '01912345678',
    company: 'وزارة الصناعة والتجارة',
    type: 'زائر',
    photo: 'https://i.pravatar.cc/150?img=18',
    isBlacklisted: false,
  },
];

export const mockVisits: Visit[] = [
  {
    id: 'visit-001',
    visitorId: 'vis-001',
    visitorName: 'أحمد محمد السيد',
    nationalId: '29801234567891',
    mobile: '01012345678',
    company: 'شركة الدلتا للمقاولات',
    type: 'مقاول',
    purpose: 'صيانة',
    hostDepartment: 'الإنتاج',
    hostEmployee: 'م. هشام عبد العزيز',
    gate: 'البوابة الرئيسية',
    securityOfficer: 'عمر سالم',
    entryTime: '2026-08-09T07:30:00',
    exitTime: undefined,
    duration: undefined,
    vehiclePlate: 'أ ب ج ١٢٣٤',
    passengersCount: 3,
    badgeNumber: 'B-041',
    status: 'داخل',
    safetyAcknowledged: true,
    notes: 'صيانة دورية لخطوط الإنتاج',
  },
  {
    id: 'visit-002',
    visitorId: 'vis-002',
    visitorName: 'محمود عبد الرحمن خليل',
    nationalId: '29503214567892',
    mobile: '01123456789',
    company: 'مصنع النيل للكيماويات',
    type: 'مورد',
    purpose: 'توريد مواد',
    hostDepartment: 'المخازن',
    hostEmployee: 'أ. رامي الشرقاوي',
    gate: 'بوابة الشاحنات',
    securityOfficer: 'محمد الجندي',
    entryTime: '2026-08-09T08:15:00',
    exitTime: undefined,
    duration: undefined,
    vehiclePlate: 'د هـ و ٥٦٧٨',
    passengersCount: 1,
    badgeNumber: 'B-042',
    status: 'داخل',
    safetyAcknowledged: true,
  },
  {
    id: 'visit-003',
    visitorId: 'vis-003',
    visitorName: 'كريم طارق عبد الله',
    nationalId: '29701234567893',
    mobile: '01234567890',
    company: 'شركة سيناء للتوريدات',
    type: 'سائق شاحنة',
    purpose: 'تسليم شحنة',
    hostDepartment: 'المخازن',
    hostEmployee: 'أ. رامي الشرقاوي',
    gate: 'بوابة الشاحنات',
    securityOfficer: 'محمد الجندي',
    entryTime: '2026-08-09T06:00:00',
    exitTime: undefined,
    duration: undefined,
    vehiclePlate: 'ز ح ط ٩٠١٢',
    passengersCount: 2,
    badgeNumber: 'B-040',
    status: 'منتهية الصلاحية',
    safetyAcknowledged: true,
    notes: 'تجاوز وقت الزيارة المحدد بساعتين',
  },
  {
    id: 'visit-004',
    visitorId: 'vis-005',
    visitorName: 'عمرو فاروق النجار',
    nationalId: '29601234567895',
    mobile: '01612345678',
    company: 'مجموعة الشرق للصيانة',
    type: 'عامل خارجي',
    purpose: 'صيانة',
    hostDepartment: 'الكهرباء والأجهزة',
    hostEmployee: 'م. أشرف حلمي',
    gate: 'البوابة الرئيسية',
    securityOfficer: 'عمر سالم',
    entryTime: '2026-08-09T07:00:00',
    exitTime: undefined,
    duration: undefined,
    vehiclePlate: undefined,
    passengersCount: 1,
    badgeNumber: 'B-039',
    status: 'داخل',
    safetyAcknowledged: true,
  },
  {
    id: 'visit-005',
    visitorId: 'vis-006',
    visitorName: 'طارق عادل منصور',
    nationalId: '29201234567896',
    mobile: '01712345678',
    company: 'الشركة المصرية للمشتريات',
    type: 'عميل',
    purpose: 'اجتماع عمل',
    hostDepartment: 'المبيعات',
    hostEmployee: 'أ. دينا مصطفى',
    gate: 'البوابة الرئيسية',
    securityOfficer: 'عمر سالم',
    entryTime: '2026-08-09T09:00:00',
    exitTime: undefined,
    duration: undefined,
    vehiclePlate: 'ي ك ل ٣٤٥٦',
    passengersCount: 2,
    badgeNumber: 'B-043',
    status: 'داخل',
    safetyAcknowledged: true,
  },
  {
    id: 'visit-006',
    visitorId: 'vis-007',
    visitorName: 'خالد سعيد الزيات',
    nationalId: '29401234567897',
    mobile: '01812345678',
    company: 'شركة الإسكندرية للكيماويات',
    type: 'مورد',
    purpose: 'توريد مواد',
    hostDepartment: 'المشتريات',
    hostEmployee: 'أ. سلوى فتحي',
    gate: 'بوابة الشاحنات',
    securityOfficer: 'حسام البدري',
    entryTime: '2026-08-09T05:30:00',
    exitTime: '2026-08-09T07:45:00',
    duration: '2 ساعة 15 دقيقة',
    vehiclePlate: 'م ن س ٧٨٩٠',
    passengersCount: 1,
    badgeNumber: 'B-038',
    status: 'خرج',
    safetyAcknowledged: true,
  },
  {
    id: 'visit-007',
    visitorId: 'vis-008',
    visitorName: 'يوسف نبيل الحداد',
    nationalId: '29101234567898',
    mobile: '01912345678',
    company: 'وزارة الصناعة والتجارة',
    type: 'زائر',
    purpose: 'تفتيش',
    hostDepartment: 'الجودة والسلامة',
    hostEmployee: 'م. ناصر الدين علي',
    gate: 'البوابة الرئيسية',
    securityOfficer: 'عمر سالم',
    entryTime: '2026-08-09T10:00:00',
    exitTime: undefined,
    duration: undefined,
    vehiclePlate: 'ع غ ف ١١٢٢',
    passengersCount: 4,
    badgeNumber: 'B-044',
    status: 'داخل',
    safetyAcknowledged: true,
    notes: 'وفد رسمي من الوزارة — زيارة تفتيش مُعلنة',
  },
  {
    id: 'visit-008',
    visitorId: 'vis-001',
    visitorName: 'أحمد محمد السيد',
    nationalId: '29801234567891',
    mobile: '01012345678',
    company: 'شركة الدلتا للمقاولات',
    type: 'مقاول',
    purpose: 'صيانة',
    hostDepartment: 'الإنتاج',
    hostEmployee: 'م. هشام عبد العزيز',
    gate: 'البوابة الرئيسية',
    securityOfficer: 'حسام البدري',
    entryTime: '2026-08-08T08:00:00',
    exitTime: '2026-08-08T14:30:00',
    duration: '6 ساعات 30 دقيقة',
    vehiclePlate: 'أ ب ج ١٢٣٤',
    passengersCount: 2,
    badgeNumber: 'B-035',
    status: 'خرج',
    safetyAcknowledged: true,
  },
  {
    id: 'visit-009',
    visitorId: 'vis-002',
    visitorName: 'محمود عبد الرحمن خليل',
    nationalId: '29503214567892',
    mobile: '01123456789',
    company: 'مصنع النيل للكيماويات',
    type: 'مورد',
    purpose: 'توريد مواد',
    hostDepartment: 'المخازن',
    hostEmployee: 'أ. رامي الشرقاوي',
    gate: 'بوابة الشاحنات',
    securityOfficer: 'محمد الجندي',
    entryTime: '2026-08-08T10:00:00',
    exitTime: '2026-08-08T12:00:00',
    duration: '2 ساعة',
    vehiclePlate: 'د هـ و ٥٦٧٨',
    passengersCount: 1,
    badgeNumber: 'B-036',
    status: 'خرج',
    safetyAcknowledged: true,
  },
  {
    id: 'visit-010',
    visitorId: 'vis-006',
    visitorName: 'طارق عادل منصور',
    nationalId: '29201234567896',
    mobile: '01712345678',
    company: 'الشركة المصرية للمشتريات',
    type: 'عميل',
    purpose: 'اجتماع عمل',
    hostDepartment: 'المبيعات',
    hostEmployee: 'أ. دينا مصطفى',
    gate: 'البوابة الرئيسية',
    securityOfficer: 'عمر سالم',
    entryTime: '2026-08-07T09:30:00',
    exitTime: '2026-08-07T11:00:00',
    duration: '1 ساعة 30 دقيقة',
    vehiclePlate: 'ي ك ل ٣٤٥٦',
    passengersCount: 1,
    badgeNumber: 'B-030',
    status: 'خرج',
    safetyAcknowledged: true,
  },
  {
    id: 'visit-011',
    visitorId: 'vis-005',
    visitorName: 'عمرو فاروق النجار',
    nationalId: '29601234567895',
    mobile: '01612345678',
    company: 'مجموعة الشرق للصيانة',
    type: 'عامل خارجي',
    purpose: 'صيانة',
    hostDepartment: 'الكهرباء والأجهزة',
    hostEmployee: 'م. أشرف حلمي',
    gate: 'البوابة الرئيسية',
    securityOfficer: 'عمر سالم',
    entryTime: '2026-08-07T07:00:00',
    exitTime: '2026-08-07T16:00:00',
    duration: '9 ساعات',
    vehiclePlate: undefined,
    passengersCount: 1,
    badgeNumber: 'B-028',
    status: 'خرج',
    safetyAcknowledged: true,
  },
  {
    id: 'visit-012',
    visitorId: 'vis-008',
    visitorName: 'يوسف نبيل الحداد',
    nationalId: '29101234567898',
    mobile: '01912345678',
    company: 'وزارة الصناعة والتجارة',
    type: 'زائر',
    purpose: 'زيارة رسمية',
    hostDepartment: 'الإدارة العليا',
    hostEmployee: 'م. وليد الشافعي',
    gate: 'البوابة الرئيسية',
    securityOfficer: 'حسام البدري',
    entryTime: '2026-08-06T11:00:00',
    exitTime: '2026-08-06T13:30:00',
    duration: '2 ساعة 30 دقيقة',
    vehiclePlate: 'ع غ ف ١١٢٢',
    passengersCount: 3,
    badgeNumber: 'B-022',
    status: 'خرج',
    safetyAcknowledged: true,
  },
];

export const mockBlacklist: BlacklistEntry[] = [
  {
    id: 'bl-001',
    name: 'سامي حسن إبراهيم',
    nationalId: '29901234567894',
    reason: 'تصرف مخالف لقواعد السلامة في زيارة سابقة — التدخين في منطقة محظورة',
    addedBy: 'م. ناصر الدين علي (HSE)',
    addedDate: '2026-07-15T10:00:00',
  },
  {
    id: 'bl-002',
    name: 'فتحي عبد الوهاب',
    nationalId: '29301234500001',
    reason: 'سرقة معدات من المخازن',
    addedBy: 'عمر سالم (الأمن)',
    addedDate: '2026-06-20T14:00:00',
  },
];

export const hourlyVisitData = [
  { hour: '06:00', count: 2 },
  { hour: '07:00', count: 5 },
  { hour: '08:00', count: 8 },
  { hour: '09:00', count: 6 },
  { hour: '10:00', count: 4 },
  { hour: '11:00', count: 3 },
  { hour: '12:00', count: 1 },
  { hour: '13:00', count: 2 },
  { hour: '14:00', count: 4 },
  { hour: '15:00', count: 3 },
  { hour: '16:00', count: 1 },
  { hour: '17:00', count: 0 },
];